import { updateOne } from './update-one'
// eslint-disable-next-line import/no-anonymous-default-export
export default { updateOne }
